import { computed } from 'vue';
import { dialogFromBtn } from '@/utils/staticData';
export default {
  props: {
    dialogTitle: {
      type: String,
      default: "物资类型"
    },
    dialogVisible: {
      type: Boolean,
      default: true
    },
    hasDialogFooter: {
      type: Boolean,
      default: true
    },
    dialogType: {
      type: String,
      default: "view"
    }
  },

  setup(props, context) {
    const visible = computed(() => props.dialogVisible);
    let btns = computed(() => {
      return dialogFromBtn.filter(v => {
        let rexg = []; // 存放过滤条件

        switch (props.dialogType) {
          case 'view':
            Object.assign(rexg, ['delete', 'save', 'cancel']);
            break;

          case 'change':
            Object.assign(rexg, ['import', 'delete', 'export', 'close']);
            break;

          case 'edit':
          case 'add':
          case 'check':
          case 'import':
          case 'export':
            Object.assign(rexg, ['delete', 'close']);
            break;

          default:
            break;
        } // 返回满足条件的按钮


        if (!rexg.includes(v.key)) return v;
      });
    });

    function handleClick(type) {
      context.emit('handleClick', type);
    }

    function closeDialog() {
      context.emit('closeDialog');
    }

    return {
      visible,
      btns,
      handleClick,
      closeDialog
    };
  }

};